import { render, staticRenderFns } from "./EffectiveLearning.vue?vue&type=template&id=5f121468&scoped=true&"
import script from "./EffectiveLearning.vue?vue&type=script&lang=js&"
export * from "./EffectiveLearning.vue?vue&type=script&lang=js&"
import style0 from "./EffectiveLearning.vue?vue&type=style&index=0&id=5f121468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f121468",
  null
  
)

export default component.exports